import { useState, useEffect } from "react";
import { Route, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import AdminDashboardNavbar from "./Header";
import AdminDashboardSidebar from "../Admin-Sidebar";

import { getCurrentUser, logout } from "../../api-config/config";
const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  height: "100vh",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function AdminDashboardLayout() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const loggedUser = getCurrentUser();
  console.log("adminnnn");
  const checkUserToken = () => {
    if (loggedUser === null) {
      navigate("/login", { replace: true });
    }
  };
  useEffect(() => {
    checkUserToken();
  }, []);
  return (
    <RootStyle>
      <AdminDashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <AdminDashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
